var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { Container, Col } from "reactstrap";
import { space } from "styled-system";
import { COLOR } from "../../theme/constants";
export var InformationSectionWrapper = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  h6 {\n    max-width: 760px;\n    margin: 3rem auto;\n  }\n\n  ", "\n"], ["\n  text-align: center;\n  h6 {\n    max-width: 760px;\n    margin: 3rem auto;\n  }\n\n  ", "\n"])), space);
export var Information = styled(Col)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
export var InformationIcon = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 74px;\n  height: 74px;\n  border-radius: 50%;\n  margin: 0 auto;\n  background-color: ", ";\n  margin-bottom: 2rem;\n"], ["\n  width: 74px;\n  height: 74px;\n  border-radius: 50%;\n  margin: 0 auto;\n  background-color: ", ";\n  margin-bottom: 2rem;\n"])), COLOR.brandOrange);
export var InformationTitle = styled.h3(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-weight: 700;\n  font-size: 1rem;\n  margin: 0 auto 0.8125rem auto;\n  max-width: 270px;\n  color: ", ";\n"], ["\n  font-weight: 700;\n  font-size: 1rem;\n  margin: 0 auto 0.8125rem auto;\n  max-width: 270px;\n  color: ", ";\n"])), COLOR.brandGreen);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;